import { combineReducers } from "redux";
import System from "./slice/system";
import ProductListingFilterBoxSelection from "./slice/model/ProductListingFilterBoxSelection";
import ProductListingFilterApplied from "./slice/model/ProductListingFilterApplied";
import ProductListingFilterBoxActiveSelection from "./slice/model/ProductListingFilterBoxActiveSelection";
import ProductListingSettings from "./slice/model/ProductListingSettings";
import ProductInventoryPrice from "./slice/model/ProductInventoryPrice";
import ProductDetail from "./slice/model/ProductDetail";
import ProductCompare from "./slice/model/ProductCompare";
import Cart from "./slice/model/Cart";
import OpenQuote from "./slice/model/OpenQuote";
import QuoteDetail from "./slice/model/QuoteDetail";
import QuoteSearchListingFilterBox from "./slice/model/QuoteSearchListingFilterBox";
import ProductListing from "./slice/model/ProductListing";
import BOM from "./slice/model/BOM";
import BOMFieldActivated from "./slice/model/BOM/BOMFieldActivated";
import BOMDownloadPopup from "./slice/model/BOM/BOMDownloadPopup";
import BOMExactMatch from "./slice/model/BOM/BOMExactMatch";
import Order from "./slice/model/Order";
import FilterSelection from "./slice/model/FilterSelection";
import OrderHistoryUI from "./slice/model/Order/OrderHistoryUI";
import Profile from "./slice/model/Profile";
import HomePageContent from "./slice/model/HomePageContent";
import User from "./slice/model/Admin/User";
import AdminCommon from "./slice/model/Admin/AdminCommon";
import Account from "./slice/model/Admin/Account";
import AdminOrders from "./slice/model/Admin/Order";
import AdminOrdersInfo from "./slice/model/Admin/OrderInsightInfo";
import AdminOrdersList from "./slice/model/Admin/OrderInsightList";
import ObjCommonFilter from "./slice/model/ObjCommonFilter";
import DesignHub from "./slice/model/DesignHub";

export default combineReducers({
    system: System,
    // View
    Cart: Cart,
    ProductListingSettings: ProductListingSettings,
    ProductListingFilterBoxSelection: ProductListingFilterBoxSelection,
    ProductListingFilterBoxActiveSelection: ProductListingFilterBoxActiveSelection,
    ProductListingFilterApplied: ProductListingFilterApplied,
    QuoteSearchListingFilterBox: QuoteSearchListingFilterBox,
    // Models
    model_ProductInventoryPrice: ProductInventoryPrice,
    model_ProductListing: ProductListing,
    model_ProductDetail: ProductDetail,
    model_ProductCompare: ProductCompare,
    model_OpenQuote: OpenQuote,
    model_QuoteDetail: QuoteDetail,
    model_BOM: BOM,
    model_BOM_BOMFieldActivated: BOMFieldActivated,
    model_BOM_BOMDownloadPopup: BOMDownloadPopup,
    model_BOM_BOMExactMatch: BOMExactMatch,
    model_Order: Order,
    model_filter_selection: FilterSelection,
    model_OrderHistory__UI: OrderHistoryUI,
    model_Profile: Profile,
    model_HomePageContent: HomePageContent,
    model_Admin: User,
    model_Admin_Common: AdminCommon,
    model_Obj_common_filter: ObjCommonFilter,
    model_Admin_Account_list: Account,
    model_Admin_Orders_list: AdminOrders,
    model_Admin_Orders_insight_info: AdminOrdersInfo,
    model_Admin_Orders_insight_list: AdminOrdersList,
    model_DesignHub: DesignHub
});
